import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// helpers
import {
  addCategory as addCategoryApi,
  updateCategory as updateCategoryApi,
  getCategory as getCategoryApi,
  deleteCategory as deleteCategoryApi,
} from "../../helpers/";

// actions
import {
  categoryApiResponseSuccess,
  categoryApiResponseError,
  getCategory,
} from "./actions";

// constants
import { CategoryActionTypes } from "./constants";

interface categoryData {
  payload: {
    id: number;
    name: string;
    isCamp: any;
  };
  type: string;
}

function* createCategory({
  payload: { name, isCamp },
  type,
}: categoryData): SagaIterator {
  try {
    const response = yield call(addCategoryApi, {
      name,
      isCamp,
    });
    

    const categoryData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      categoryApiResponseSuccess(
        CategoryActionTypes.CREATE_CATEGORY,
        categoryData
      )
    );
    yield put(getCategory());
  } catch (error: any) {
    yield put(
      categoryApiResponseError(CategoryActionTypes.CREATE_CATEGORY, error)
    );
  }
}

function* updateCategory({
  payload: { id, name, isCamp },
}: categoryData): SagaIterator {
  try {
    const response = yield call(updateCategoryApi, id, {
      name,
      isCamp,
    });
    const categoryData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      categoryApiResponseSuccess(
        CategoryActionTypes.UPDATE_CATEGORY,
        categoryData
      )
    );
    yield put(getCategory());
  } catch (error: any) {
    yield put(
      categoryApiResponseError(CategoryActionTypes.UPDATE_CATEGORY, error)
    );
  }
}

function* getCategories(): SagaIterator {
  try {
    const response = yield call(getCategoryApi);
    const categoryData = response?.data?.categories;

    yield put(
      categoryApiResponseSuccess(CategoryActionTypes.GET_CATEGORY, categoryData)
    );
  } catch (error: any) {
    yield put(
      categoryApiResponseError(CategoryActionTypes.GET_CATEGORY, error)
    );
  }
}

function* deleteCategory({ payload: { id } }: categoryData): SagaIterator {
  try {
    const response = yield call(deleteCategoryApi, id);
    const categoryData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      categoryApiResponseSuccess(
        CategoryActionTypes.DELETE_CATEGORY,
        categoryData
      )
    );
    yield put(getCategory());
  } catch (error: any) {
    yield put(
      categoryApiResponseError(CategoryActionTypes.DELETE_CATEGORY, error)
    );
  }
}

export function* watchCreateCategory() {
  yield takeEvery(CategoryActionTypes.CREATE_CATEGORY, createCategory);
}
export function* watchUpdateCategory() {
  yield takeEvery(CategoryActionTypes.UPDATE_CATEGORY, updateCategory);
}
export function* watchGetCategory() {
  yield takeEvery(CategoryActionTypes.GET_CATEGORY, getCategories);
}

export function* watchDeleteCategory() {
  yield takeEvery(CategoryActionTypes.DELETE_CATEGORY, deleteCategory);
}

function* categorySaga() {
  yield all([
    fork(watchCreateCategory),
    fork(watchUpdateCategory),
    fork(watchDeleteCategory),
    fork(watchGetCategory),
  ]);
}

export default categorySaga;
